import { render, staticRenderFns } from "./BuildingShowRoomsTab.vue?vue&type=template&id=4caa6988"
import script from "./BuildingShowRoomsTab.vue?vue&type=script&lang=ts"
export * from "./BuildingShowRoomsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports